var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.motivo)?_c('b-badge',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"mx-1",attrs:{"variant":"warning","title":'Este documento foi cancelado: ' + _vm.motivo}},[_c('font-awesome-icon',{attrs:{"icon":"ban"}}),_vm._v(" Cancelado ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }